import React from "react";
import "./GridCard.scss";

class GridCards extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [
        {
          id: 0,
          url:
            "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1597939352/EitherOrBothAndAlso/04_Mirror_an5idm.jpg",
          text:
            "‘[…]The mirror is, after all, a utopia, since it is aplaceless place",
          style: "small-card",
          title: "Mirror_01",
          selected: false,
        },
        {
          id: 1,
          url:
            "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1597939347/EitherOrBothAndAlso/04-_-Rec_Eng_ue0h1q.gif",
          text:
            " ‘“[…]The artist creates a situation, where the building , the urban environment and the participants relate in new “paranormal” ways. […]",
          style: "small-card",
          title: "Rec_04",
          selected: false,
        },
        {
          id: 2,
          url:
            "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1597939354/EitherOrBothAndAlso/10_-Tweet_ENG_r3cduc.gif",
          text:
            "The heterotopia is capable of juxtaposing in a single real place several spaces, several sites that are in themselves incompatible.",
          style: "small-card",
          title: "Tweet_07",
          selected: false,
        },
        {
          id: 3,
          url:
            "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1597939354/EitherOrBothAndAlso/05_Theatre_ewlraa.jpg",
          text:
            "‘[…]The mirror is, after all, a utopia, since it is a placeless place",
          style: "small-card",
          title: "Theater_02",
          selected: false,
        },
        {
          id: 4,
          url:
            "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1597939346/EitherOrBothAndAlso/08_-Tweener_ENG_cectsq.gif",
          text:
            "[…]Because these places are absolutely different from all the sites that they reflect and speak about. […]",
          style: "small-card",
          title: "Tweener_05",
          selected: false,
        },
        {
          id: 5,
          url:
            "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1597939355/EitherOrBothAndAlso/11_Shadow_jaxvep.gif",
          text:
            "[…]The mirror is, after all, a utopia, since it is a placeless place",
          style: "small-card",
          title: "Shadow_08",
          selected: false,
        },
        {
          id: 6,
          url:
            "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1597939350/EitherOrBothAndAlso/10_Glitch-copia_eng_xmvdst.gif",
          text:
            "“Heterotopias always require the existence of a opening-closing system , which will isolate them and make them easily reached” ",
          style: "small-card",
          title: "GLITCH_10",
          selected: false,
        },
        {
          id: 7,
          url:
            "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1597939350/EitherOrBothAndAlso/10_Glitch-copia_eng_xmvdst.gif",
          text:
            "Spatially, the position of the “in-between” implies a “middle location” between two facts and two contradictory spaces, for example: the “inside-out”, the “here and there”, and “this or the other (side)”.",
          style: "small-card",
          title: "Inside Out_03",
          selected: false,
        },
        {
          id: 8,
          url:
            "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1597939346/EitherOrBothAndAlso/09_Room_ENG_s9xo0m.gif",
          text:
            "‘Its first principle is that there is probably not a single culture in the world that fails to constitute heterotopias.",
          style: "small-card",
          title: "Room_06",
          selected: false,
        },
        {
          id: 9,
          url:
            "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1597939344/EitherOrBothAndAlso/13_Fest_aaxezs.gif",
          text:
            "‘[…]Such, for example, are the fairgrounds, these’ marvellous empty sites on the outskirts of cities that teem once or twice a year with stands, displays, heteroclite objects",
          style: "small-card",
          title: "Fest_09",
          selected: false,
        },

      ],
    };
  }

  changeStyle = (id) => {
    let items = [...this.state.items];
    console.log(items);
    if (items[id] != null) {
      items[id].selected = !items[id].selected;

      if (items[id].selected) {
        items[id].style = "big-card";
      } else {
        items[id].style = "small-card";
      }
    }

    items.forEach((item) => {
      if (item.id !== id) {
        item.selected = false;
        item.style = "small-card";
      }
    });
    console.log(items[id].selected);
    this.setState({ items });
  };
  render() {
    return (
      <div className="either-or">
        <div className="games container underline--magical">
          <h1 className=" center-al">Games</h1>
        </div>
        <div className="container">
          <div className="card-columns">
            {this.state.items.map((item) => {
              return (
                <div
                  className={`${item.style}`}
                  onClick={() => {
                    this.changeStyle(item.id);
                  }}
                >
                  <div className="card page-link c0 cd">
                    <img
                      className="card-img-top"
                      src={item.url}
                      alt="Card cap 1"
                    />
                    <div className="card-body">
                      <h5 className="card-title">{item.title}</h5>
                      <p className="card-text">{item.text}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="container underline--magical margin1 marginbottom center-al">
          <h1>Urban equipment</h1>
          <h3>Column</h3>
        </div>
        <div className="container">
          <div className=" row">
            <div className="text-one">
              <p class="font2">
                The pedestrian composition consists of one a set of urban
                equipment aimed at framing and supporting the project, both in
                terms of technological requirements, as well as in the more
                general the architecture of an urban landscape. The equipment
                consists initially of the columns, which are apart from light
                sources and bases for the headlamps. The column has the
                potential revolving and transporting the data which are the
                bases - lamps for the purpose of correct and effortless
                installation of the projector. Columns were then designed to be
                able to equipped, through adaptations, with the systems sense,
                sound or computers. Still exists a series of objects such as the
                floor, for the setting of toys and their passage cables, seats,
                entry balls, or seats columns with the cameras that complement
                it composition of space.
              </p>
            </div>
          </div>
        </div>
        <div className="container margin">
          <div className="row">
            <div className="col-3">
              <img
                className="card-img-top"
                src="https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599149390/EitherOrBothAndAlso/kolona_qjwzgq.png"
                alt="Projector column construction detail"
              />
            </div>
            <div className="col-8 margin2 ">
              <img
                className="card-img-top2"
                src="https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599151617/EitherOrBothAndAlso/Recurso_5_eutqdc.png"
                alt="card 2"
              />
            </div>
          </div>
        </div>
        <div className="container margin1 marginbottom">
          <div className="font">
            <p>
              <b>1.</b>Rotation Ring
            </p>
            <p className="margin3">
              <b>2.</b>Puley of vertical Translation
            </p>
            <p className="margin3">
              <b>3.</b>Electric Motor responsible for
            </p>
            <p>the rotation of the outer ring</p>
            <p className="margin3">
              <b>4.</b>Electric Motor for vertical translationc
            </p>
            <p className="margin3">
              <b>5.</b>Electric Motor for base rotation
            </p>
            <p className="margin3">
              <b>6.</b>Rack
            </p>
            <p classNAme="margin3">
              <b>7.</b>Pignion
            </p>
            <p className="margin3">
              <b>8.</b>Rotation pulleys
            </p>
            <p className="margin3">
              <b>9.</b>Translation pulleys
            </p>
          </div>

          <div className="container underline--magical margin1 marginbottom center-al">
            <h1>Urban equipment</h1>
            <h3>Small columns</h3>
          </div>
        </div>
        <div className=" container">
          <div class=" row">
            <div className="col-2">
              <p className="font-center">KINECT</p>
              <img
                className="columns-imgs"
                src="https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599153865/EitherOrBothAndAlso/urbanequipv1n_hpgutz.png"
                alt="Kinect construction detail"
              />
            </div>
            <div className="col-4">
              <p className="font-center">LEAP MOTION/PC</p>
              <img
                className="columns-imgs"
                src="https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599153865/EitherOrBothAndAlso/urbanequipv2n_jtd86j.png"
                alt="Leap Motion construction detail"
              />
            </div>

            <div className="col-2">
              <p className="font-center">MICROPHONE</p>
              <img
                className="columns-imgs"
                src="https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599153865/EitherOrBothAndAlso/urbanequipv3n_anohcv.png"
                alt="Microphone construction detail"
              />
            </div>
            <div className="col-2">
              <p className="font-center">SPINNING WHEEL</p>
              <img
                className="columns-imgs"
                src="https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599153865/EitherOrBothAndAlso/urbanequipv4n_chltnf.png"
                alt="Spinning wheel construction detail"
              />
            </div>

            <div className="col-2">
              <p className="font-center">SPEAKER</p>
              <img
                className="columns-imgs"
                src="https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599153865/EitherOrBothAndAlso/urbanequipv5n_xufr4v.png"
                alt="Speaker wheel construction detail"
              />
            </div>
          </div>
        </div>
        <div className="center-al container underline--magical margin1 marginbottom">
          <h1>Urban equipment</h1>
          <h3>-more-</h3>
        </div>
        <div className="container margin1 marginbottom">
          <div className="row">
            <div className="col-lg-6">
              <p className="center-al">FLOOR</p>
              <img
                className="columns-imgs "
                src="https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599155537/EitherOrBothAndAlso/03-_-%CE%91%CF%83%CF%84%CE%B9%CE%BA%CF%8C%CF%82-%CE%95%CE%BE_03_f4qn9x.png"
                alt="Terrain diagram"
              />
              <div className="container row">
                <div class="col-lg-10">
                  {" "}
                  <p class="center-al">MOTION SENSITIVE LAMPS</p>
                  <img src="https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599155537/EitherOrBothAndAlso/03-_-%CE%91%CF%83%CF%84%CE%B9%CE%BA%CF%8C%CF%82-%CE%95%CE%BE_09_vmgaxp.png" alt="Motion sensitive lamps detail" />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <p className="center-al">BENCHES</p>
              <img
                className="columns-imgs "
                src="https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599155537/EitherOrBothAndAlso/03-_-%CE%91%CF%83%CF%84%CE%B9%CE%BA%CF%8C%CF%82-%CE%95%CE%BE_06_vk5frb.png"
                alt="Benches construction detail"
              />
            </div>
          </div>

          {/* <div>
          <div className="col-9">
            <div
              data-configid="28399825/64420644"
              style="width:100%; height:500px;"
              class="issuuembed"
            ></div>
            <script
              type="text/javascript"
              src="//e.issuu.com/embed.js"
              async="true"
            ></script>
          </div>
        </div> */}
        </div>
      </div>
    );
  }
}

export default GridCards;
